module.exports = __webpack_public_path__ + "static/media/neural_network.2c886e22.png";